/** The media API of the current panel (admin and vendor have the same endpoints, scoped differently). */

import {
  adminMediaDestroy,
  adminMediaFoldersCreate,
  adminMediaFoldersDestroy,
  adminMediaFoldersList,
  adminMediaFoldersPartialUpdate,
  adminMediaList,
  adminMediaPartialUpdate,
  adminMediaRestoreCreate,
  adminMediaRetrieve,
  adminMediaVideosCreate,
  vendorMediaDestroy,
  vendorMediaFoldersCreate,
  vendorMediaFoldersDestroy,
  vendorMediaFoldersList,
  vendorMediaFoldersPartialUpdate,
  vendorMediaList,
  vendorMediaPartialUpdate,
  vendorMediaRestoreCreate,
  vendorMediaRetrieve,
  vendorMediaVideosCreate,
  type AdminMediaListParams,
} from "@motolynk/api-client";

export type MediaPanel = "admin" | "vendor";
export type MediaListParams = AdminMediaListParams;

export const MEDIA_API = {
  admin: {
    base: "/api/v1/admin/media",
    list: adminMediaList,
    retrieve: adminMediaRetrieve,
    update: adminMediaPartialUpdate,
    destroy: adminMediaDestroy,
    restore: adminMediaRestoreCreate,
    video: adminMediaVideosCreate,
    folders: adminMediaFoldersList,
    createFolder: adminMediaFoldersCreate,
    renameFolder: adminMediaFoldersPartialUpdate,
    deleteFolder: adminMediaFoldersDestroy,
  },
  vendor: {
    base: "/api/v1/vendor/media",
    // the vendor API has no `vendor` filter: it only ever returns the vendor's own files
    list: (params?: MediaListParams) => {
      const { vendor: _ignored, ...own } = params ?? {};
      return vendorMediaList(own);
    },
    retrieve: vendorMediaRetrieve,
    update: vendorMediaPartialUpdate,
    destroy: (uid: string, params?: { force?: boolean }) => {
      void params; // vendors can't force-delete media that is in use
      return vendorMediaDestroy(uid);
    },
    restore: vendorMediaRestoreCreate,
    video: vendorMediaVideosCreate,
    folders: vendorMediaFoldersList,
    createFolder: vendorMediaFoldersCreate,
    renameFolder: vendorMediaFoldersPartialUpdate,
    deleteFolder: vendorMediaFoldersDestroy,
  },
};

export const mediaKeys = {
  all: (panel: MediaPanel) => ["media", panel] as const,
  list: (panel: MediaPanel, params: object) => ["media", panel, "list", params] as const,
  item: (panel: MediaPanel, uid: string) => ["media", panel, "item", uid] as const,
  folders: (panel: MediaPanel) => ["media", panel, "folders"] as const,
};
